const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
)

export function register(config) {
  if ('serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href)
    if (publicUrl.origin !== window.location.origin) return

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config)
      } else {
        registerValidSW(swUrl, config)
      }
    })
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then((registration) => {
    registration.onupdatefound = () => {
      const worker = registration.installing
      if (!worker) return
      worker.onstatechange = () => {
        if (worker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            if (config && config.onUpdate) config.onUpdate(registration)
          } else {
            if (config && config.onSuccess) config.onSuccess(registration)
          }
        }
      }
    }
  }).catch((error) => console.error('Service worker error:', error))
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const ct = response.headers.get('content-type')
      if (response.status === 404 || (ct && !ct.includes('javascript'))) {
        navigator.serviceWorker.ready.then((r) => r.unregister().then(() => window.location.reload()))
      } else {
        registerValidSW(swUrl, config)
      }
    })
    .catch(() => console.log('Pas de réseau. Mode hors ligne.'))
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((r) => r.unregister())
      .catch((e) => console.error(e.message))
  }
}
